import { render, staticRenderFns } from "./fileWorkTech.vue?vue&type=template&id=39402c58&scoped=true&"
import script from "./fileWorkTech.vue?vue&type=script&lang=js&"
export * from "./fileWorkTech.vue?vue&type=script&lang=js&"
import style0 from "./fileWorkTech.vue?vue&type=style&index=0&id=39402c58&scoped=true&lang=css&"
import style1 from "./fileWorkTech.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39402c58",
  null
  
)

export default component.exports